import React from 'react'
import KeyboardButton from './KeyboardButton'
import useKeyPress from '../useKeyPress'
import './Landing.css'
import { Link, withRouter } from 'react-router-dom'

const Landing = ({ history }) => {
  const handleNext = () => history.push('/lessons/1')

  useKeyPress('Enter', handleNext)

  return (
    <section className='jumbotron text-center' style={{ position: 'relative' }}>
      <div className='container'>

        <div className='price-tag'>  Всего 799₽</div>

        <h1 className='jumbotron-heading'>Клавиатурный тренажер «слепой» печати</h1>
        <p className='lead text-muted' >Навык слепой печати вам точно пригодится. Начтите с простого, и через две недели вы перестанете смотреть на клавиатуру</p>
        <p style={{ color: '#6c757d', fontWeight: 300 }}>
          <Link to='/lessons/1' className='btn btn-lg btn-primary my-2'> Попробовать бесплатно</Link>
          <br />
      Нажмите <KeyboardButton> Enter⏎ </KeyboardButton>, чтобы продолжить</p>
      </div>
    </section>

  )
}

export default withRouter(Landing)



// WEBPACK FOOTER //
// ./src/components/Landing.js